import { initializeApp } from "firebase/app";
import config from "./config";
import { getAuth } from "firebase/auth";

const Firebase = initializeApp(config.firebase);

export const auth = getAuth();
export default Firebase;
